
import { useState } from "react";
import { userApiClient, businessApiClient } from "@/api";
import { logger } from "@/lib/logger";

export function useUserBusiness() {
  const fetchCurrentUser = async () => {
    return userApiClient.getCurrentUser();
  };
  
  const fetchBusinessId = async (userId: string) => {
    try {
      const business = await businessApiClient.fetchBusinessByOwnerId(userId);
      return business?.id || null;
    } catch (error) {
      logger.error({
        message: "Exception fetching business data",
        error: error instanceof Error ? error : new Error(String(error)),
        context: { userId }
      });
      return null;
    }
  };

  return {
    fetchCurrentUser,
    fetchBusinessId
  };
}
